import { EntryConfig } from '@Protium/vue-ozone-utils'
import { ModuleTree } from 'vuex'
import { StateInterface } from '@/store'
import Size from '@/models/size'

export enum ViewCollection {
  Overview = 'Overview'
}

export interface View {
  id: string;
  name: string;
  icon?: boolean
}

export interface ViewFilters {
  views: View[];
}

export interface ViewState<T> {
  activeViewName?: T | string;
  filters: ViewFilters;
  entryConfig?: EntryConfig;
  itemConfig?: EntryConfig;
  viewMode?: string | number
}

export interface ViewManagerOptions {
  modules?: ModuleTree<StateInterface>;
}

export interface ViewInstanceOptions {
  itemSize: Size;
  defaultView: string;
}
